import React from 'react';
import { useNavigate } from "react-router-dom";
import { process } from "@progress/kendo-data-query";
import useFetchWithMsal from '../services/useFetchWithMsal';
import { apiRoutes } from '../services/apiRoutes';
import { FilterData } from '../Data/FilterData';
import { SiteData } from '../Data/SiteData';
import { CustomerData } from '../Data/CustomerData';
import { Layout } from '../components/MasterPage/Layout';
import { FiltersGrid } from '../components/Grid/FiltersGrid';
import { AddEditFilterModal } from '../components/Modals/AddEditFilterModal';
import { DeleteModal } from '../components/Modals/DeleteModal';
import { AssignFilterToGroupModal } from '../components/Modals/AssignFilterToGroupModal';
import { AssignToSiteModal } from '../components/Modals/AssignToSiteModal';
import { ContextMenu } from '../components/ContextMenu';
import { htmlDecode } from "../services/Utils";

export function Filters(props) {
	let navigate = useNavigate();
	const { execute, result } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});
	const { getFilterData, postFilter, deleteFilter, assignFilterToSites, assignFilterToGroups, getUserGroups, getFilter, getFilterTitles } = FilterData({ execute: execute, customer: props.customer });
	const { getSites } = SiteData({ execute: execute, customer: props.customer });
	const { getColumns } = CustomerData({ execute: execute, customer: props.customer });

	const [titles, settitles] = React.useState({});
	const [success, setSuccess] = React.useState(false);
	const [error, setError] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [validationError, setValidationError] = React.useState(false);
	const [validationErrorMessage, setValidationErrorMessage] = React.useState("");

	const [sitesSelected, setsitesSelected] = React.useState([]);
	const [groupsSelected, setgroupsSelected] = React.useState([]);
	const [sites, setsites] = React.useState([]);
	const [groups, setgroups] = React.useState([]);
	const [localesSelected, setlocalesSelected] = React.useState([]);
	const [includeExclude, setincludeExclude] = React.useState({});
	const [downloadGrid, setdownloadGrid] = React.useState(false);
	const [showColumnSelect, setshowColumnSelect] = React.useState(false);
	const [buttonsConfig, setbuttonsConfig] = React.useState([]);
	const [localesDropdownData, setlocalesDropdownData] = React.useState([]);
	const [filteredLocales, setfilteredLocales] = React.useState([]);
	const [currentFilterId, setcurrentFilterId] = React.useState(0);
	const [showDeleteFilterModal, setshowDeleteFilterModal] = React.useState(false);
	const [showAssignToGroupModal, setshowAssignToGroupModal] = React.useState(false);
	const [showAssignToSiteModal, setshowAssignToSiteModal] = React.useState(false);
	const [show, setshow] = React.useState(false);
	const [selectedFilter, setselectedFilter] = React.useState({});
	const [filters, setfilters] = React.useState([]);
	const [originalfilters, setoriginalfilters] = React.useState([]);
	const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
	const [pending, setPending] = React.useState(false);
	const [showContext, setshowContext] = React.useState(false);
	const [dataResult, setDataResult] = React.useState(process(originalfilters, dataState));
	const dataStateChange = (event) => {
		setDataResult(process(filters, event.dataState));
		setDataState(event.dataState);
	};

	const offSet = React.useRef({ left: 0, top: 0 });
	const filterMenuClick = (filterId, e) => {
		setcurrentFilterId(filterId);
		e.preventDefault();
		offSet.current = {
			left: e.clientX,
			top: e.clientY,
		};
		setshowContext(true);
	};

	const [menuItems, setmenuItems] = React.useState([props.localizations.Delete, props.localizations.Edit, props.localizations.AssignToSite, props.localizations.AssignToGroup]);

	const rowContextClick = (e) => {
		if (e.item.text === props.localizations.Delete)
			toggleDeleteFilterModal();
		else if (e.item.text === props.localizations.Edit)
			toggleModal(currentFilterId);
		else if (e.item.text === props.localizations.AssignToSite)
			toggleAssignFilterToSite();
		else
			toggleAssignFilterToGroup();
	};

	const getData = () => {
		setPending(true);
		execute("GET", apiRoutes.documents.languages).then(
			(json) => {
				if (json != null) {
					for (var i = 0; i < json.length; i++) {
						json[i].label = (props.localizations[json[i].languageName] ?? json[i].languageName) + " - " + json[i].country;
						json[i].value = json[i].languageId;
					}
					setlocalesDropdownData(json);
					setfilteredLocales(json);
				}
			}
		);

		getUserGroups().then((data) => {
			setgroups(data);
			getFilterData(data).then((data) => {
				if (data != null) {
					setPending(false);
					setfilters(data);
					setDataResult(process(data, { skip: 0, take: 25 }));
					setDataState({ skip: 0, take: 25 });
					setoriginalfilters(data);
				}
			});
		});
		
		getSites().then((data) => {
			setsites(data);
		});

		getColumns(props.localizations, props.languageValue.localeId).then((data) => {
			settitles(getFilterTitles(data.materialColumns.concat(data.documentColumns)));
		});
	};

	const save = () => {

		setError(false);
		setValidationError(false);
		let nameUsed = false;
		filters.forEach(function (filter) { if (filter.filterName == selectedFilter.filterName && filter.id != selectedFilter.id) nameUsed = true; }
		);

		if (!nameUsed && selectedFilter.filterName && selectedFilter.filterName != "") {
			setPending(true);
			postFilter(selectedFilter, localesSelected, includeExclude).then(() => {
				setshow(!show);
				getData();
				setSuccess(true);
				setTimeout(function () {
					setSuccess(false);
				}, 5000);
			})
				.catch((error) => {
					setError(true);
					setErrorMessage(props.localizations.RetrieveSiteError);
				});
		}
		else
		{
			setSuccess(false);
			setValidationError(true);
			if (nameUsed) { setValidationErrorMessage(props.localizations.FilterUnique); } else { setValidationErrorMessage(props.localizations.FilterNameRequired); }
			
		}
	};

	const submitDeleteFilter = async () => {
		setPending(true);
		setshowDeleteFilterModal(!showDeleteFilterModal);
		deleteFilter(currentFilterId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
		.catch((error) => {
			setError(true);
			setErrorMessage(props.localizations.RetrieveSiteError);
		});
	};

	const submitAssignFilterGroupFilter = async () => {
		setPending(true);
		setshowAssignToGroupModal(!showAssignToGroupModal);
		await assignFilterToGroups(groupsSelected, currentFilterId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
		.catch((error) => {
			setError(true);
			setErrorMessage(props.localizations.RetrieveSiteError);
		});
	};

	const submitAssignSiteFilter = async () => {
		setPending(true);
		setshowAssignToSiteModal(!showAssignToSiteModal);
		await assignFilterToSites(sitesSelected, currentFilterId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
		.catch((error) => {
			setError(true);
			setErrorMessage(props.localizations.RetrieveSiteError);
		});
	};

	const handleLocalesDropdownChange = (e) => {
		let newlocalesDropdownData = localesDropdownData;
		newlocalesDropdownData.forEach(x => {
			x.show = false;
		});
		e.forEach(x => {
			let phrase = newlocalesDropdownData.find(y => x.value === y.value);
			if (phrase)
				phrase.show = true;
		});

		let locales = e;
		setlocalesSelected(locales);
		setlocalesDropdownData(newlocalesDropdownData);
		setfilteredLocales(newlocalesDropdownData);
	};

	const handleSitesDropdownChange = (e) => {
		let newsites = sites;
		newsites.forEach(x => {
			x.show = false;
		});
		e.value.forEach(x => {
			let site = newsites.find(y => x.value === y.value);
			if (site)
				site.show = true;
		});

		let selecSites = e.value;
		setsitesSelected(selecSites);
		setsites(newsites);
	};

	const handleGroupsDropdownChange = (e) => {
		let newgroups = groups;
		newgroups.forEach(x => {
			x.show = false;
		});
		e.value.forEach(x => {
			let group = newgroups.find(y => x.value === y.value);
			if (group)
				group.show = true;
		});

		let selecGroups = e.value;
		setgroupsSelected(selecGroups);
		setgroups(newgroups);
	};

	const toggleDeleteFilterModal = () => {
		setshowDeleteFilterModal(!showDeleteFilterModal);
	};

	const toggleAssignFilterToSite = () => {
		setshowAssignToSiteModal(!showAssignToSiteModal);
		let filter = originalfilters.filter(x => x.id === currentFilterId)[0];
		let selected = sites.filter(x => filter.publicSiteFilters.filter(y => y.publicSiteId === x.site.id).length > 0);
		setsitesSelected(selected);
	};

	const toggleAssignFilterToGroup = () => {
		setshowAssignToGroupModal(!showAssignToGroupModal);
		let filter = originalfilters.filter(x => x.id === currentFilterId)[0];
		let selected = groups.filter(x => filter.customerGroupFilters.filter(y => y.groupId === x.id).length > 0);
		setgroupsSelected(selected);
	};

	const toggleModal = (filterId) => {
		setshow(!show);
		if (show)
			return;

		if (filterId != null) {
			var { lSelected, includeExcludeValues, filter } = getFilter(filterId, originalfilters, filteredLocales);
			filter.filterName = htmlDecode(filter.filterName);
			setlocalesSelected(lSelected);
			setselectedFilter(filter);
			setincludeExclude(includeExcludeValues);
		}
		else {
			setselectedFilter({});
			setlocalesSelected([]);
			setincludeExclude({
				Cd1Include: [], Cd2Include: [], Cd3Include: [], Cd1Exclude: [], Cd2Exclude: [], Cd3Exclude: [], DocTypeInclude: [], DocTypeExclude: [],
				Cc1Include: [], Cc2Include: [], Cc3Include: [], MfgInclude: [], TagInclude: [], DocFormatInclude: [], DocFormatExclude: [], LocationInclude: [], LocationExclude: [],
				ExactMatchInclude: [], ExactMatchExclude: [], Cc1Exclude: [], Cc2Exclude: [], Cc3Exclude: [], MfgExclude: [], TagExclude: []
			});
		}
	};

	const [gotData, setgotData] = React.useState(false);
	React.useEffect(() => {
		if (gotData || result == null)
			return;
		setgotData(true);
	}, [execute]);

	React.useEffect(() => {
		if (props.currentTenent.CustomerId == null)
			return;
		if (!props.currentTenent.IsEditFiltersUser)
			navigate("/NoPermissions");
		if (gotData && execute != null)
			getData();
	}, [gotData, execute, props.currentTenent.CustomerId]);

	React.useEffect(() => {
		setbuttonsConfig([
			{
				type: 'primary',
				text: props.localizations.AddFilter,
				onClick: () => { toggleModal(); }
			},
			{
				type: 'secondary',
				icon: 'icon-ui-general-libraries',
				tooltip: props.localizations.Columns,
				position: "top",
				onClick: () => { setshowColumnSelect(true); }
			},
			{
				type: 'secondary',
				icon: 'icon-ui-general-download',
				tooltip: props.localizations.Download,
				position: "top",
				onClick: () => { setdownloadGrid(true); }
			}
		]);
	}, [props.localizations, execute]);

	return (
		<Layout versionNumber={props.versionNumber} success={success} setSuccess={setSuccess} error={error} setError={setError} errorMessage={errorMessage} setValidationError={setValidationError} validationErrorMessage={validationErrorMessage} buttonsConfig={buttonsConfig} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue} >
			<div>
				<FiltersGrid filterMenuClick={filterMenuClick} customer={props.customer} dateFormatId={props.customer.dateFormatId} localizations={props.localizations}
					pending={pending} filters={filters} dataState={dataState} dataResult={dataResult} dataStateChange={dataStateChange}
					showColumnSelect={showColumnSelect} downloadGrid={downloadGrid} setdownloadGrid={setdownloadGrid} setshowColumnSelect={setshowColumnSelect} />

				<ContextMenu menuItems={menuItems} offSet={offSet} rowContextClick={rowContextClick} showContext={showContext} setshowContext={setshowContext} />

				<AddEditFilterModal localizations={props.localizations} titles={titles} selectedFilter={selectedFilter} setselectedFilter={setselectedFilter}
					show={show} toggleModal={toggleModal} save={save} handleLocalesDropdownChange={handleLocalesDropdownChange} localesSelected={localesSelected}
					localesDropdownData={localesDropdownData} validationError={validationError} validationErrorMessage={validationErrorMessage}
					setincludeExclude={setincludeExclude} includeExclude={includeExclude} filteredLocales={filteredLocales} setfilteredLocales={setfilteredLocales} />
				<DeleteModal localizations={props.localizations} DeleteConfirm={props.localizations.DeleteFilterConfirm} showDeleteModal={showDeleteFilterModal} toggleDeleteModal={toggleDeleteFilterModal} submitDelete={submitDeleteFilter} />
				<AssignFilterToGroupModal localizations={props.localizations} handleGroupsDropdownChange={handleGroupsDropdownChange} groups={groups} groupsSelected={groupsSelected} showAssignToGroupModal={showAssignToGroupModal} toggleAssignFilterToGroup={toggleAssignFilterToGroup} submitAssignFilterGroupFilter={submitAssignFilterGroupFilter} />
				<AssignToSiteModal localizations={props.localizations} handleSitesDropdownChange={handleSitesDropdownChange} sites={sites} sitesSelected={sitesSelected} showAssignToSiteModal={showAssignToSiteModal} toggleAssignToSite={toggleAssignFilterToSite} submitAssignSite={submitAssignSiteFilter} />
			</div>
		</Layout>
	);
}
